// extracted by mini-css-extract-plugin
export default {"btncustom":"Button_btncustom__q1Hiu"};